module.exports = __webpack_public_path__ + "img/none.b5031844.png";